<span class="font-bold">
  {{ msg }}
</span>
<br />
@if (msgDetail) {
  <span>{{ msgDetail }}</span>
}
<br />
<br />
